import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface State {
  categoryCollection: {
    thumbnailSize: number;
    showLabels: boolean;
  };
}

const initialState: State = {
  categoryCollection: {
    thumbnailSize: 100,
    showLabels: true,
  },
};

export const userPreferences = createSlice({
  name: "userPreferences",
  initialState,
  reducers: {
    updateCategoryCollectionThumbnailSize: (
      state,
      {
        payload: thumbnailSize,
      }: PayloadAction<State["categoryCollection"]["thumbnailSize"]>
    ) => {
      state.categoryCollection.thumbnailSize = thumbnailSize;
    },
    updateCategoryCollectionShowLabels: (
      state,
      {
        payload: showLabels,
      }: PayloadAction<State["categoryCollection"]["showLabels"]>
    ) => {
      state.categoryCollection.showLabels = showLabels;
    },
  },
});

export const {
  updateCategoryCollectionThumbnailSize,
  updateCategoryCollectionShowLabels,
} = userPreferences.actions;
